import React, { Component } from 'react'
import { connect } from 'react-redux'

import classNames from './DiversityPicker.css'
import { fetch } from '../../utils/fetch'
import { prepareStructure, addLibrariesToStructure } from '../../utils/images'
import { commas } from '../../utils/string'

class DiversityPicker extends Component {
  state = {
    loading: false,
    suggestedLimit: null
  }
  fetchStats = diversity => {
    this.setState({
      loading: true,
      suggestedLimit: null
    })
    this.props.fetchStats(diversity).then(data => {
      this.setState({
        loading: false,
        suggestedLimit: data.stats.diversity.natural_diversity
      })
    })
  }
  render () {
    const { value, onChange } = this.props
    const onMouseUp = e => {
      this.props.onMouseUp && this.props.onMouseUp(e)
      this.props.showSuggestedLimit && this.fetchStats(parseFloat(e.target.value))
    }
    return (
      <label>
        Diversity
        <br />
        <span className={classNames.percentage} style={{ float: 'right' }}>
          {this.state.loading &&
            'Loading…'
          }
          {this.state.suggestedLimit &&
            'Natural diversity limit: ' + commas(this.state.suggestedLimit)
          }
        </span>
        <input
          className={classNames.range}
          type='range'
          value={value || 0}
          min={0}
          max={1}
          step={0.1}
          onChange={onChange}
          onMouseUp={onMouseUp}
        />
        <span className={classNames.percentage}>
          {Math.round(value * 100)}%
        </span>
      </label>
    )
  }
}

const mapStateToProps = ({ auth, query }) => ({
  fetchStats: diversity => {
    const body = {
      ...query.structure,
      diversity
    }
    return fetch('/search/stats', {
      method: 'post',
      body: prepareStructure(addLibrariesToStructure(body, query.libraries)),
      token: auth.token
    })
  }
})

export default connect(mapStateToProps)(DiversityPicker)



// WEBPACK FOOTER //
// ./src/components/search/DiversityPicker.js